/**
 * Centralized image URL configuration.
 * Profile pictures may exist locally (scraped) or on the dedicated server (qlickr.fr).
 * Use getLocalProfilePicUrl first, then getProfilePicUrl (server) as fallback.
 */

const IMAGES_CDN = process.env.REACT_APP_IMAGES_CDN || 'https://qlickr.fr';

/** Local path — served by Express (proxied in dev) */
export const getLocalProfilePicUrl = (username) =>
  `/instagram-profile-pictures/${username}.jpg`;

/** Server CDN path — always available if uploaded */
export const getProfilePicUrl = (username) =>
  `${IMAGES_CDN}/images/profile-pictures/${username}.jpg`;

export const getScreenshotUrl = (username) =>
  `${IMAGES_CDN}/images/profile-screenshots/${username}.jpg`;

export { IMAGES_CDN };
